import SmallNumber from '@shared/components/content/small-number';
import { cn, formatSmallNumber } from '@shared/lib/utils';
import { ClassValue } from 'clsx';

interface NumberCellProps {
  number: number;
  className?: ClassValue;
  rounded?: boolean;
  formatter?: (n: number) => string;
}

export function NumberCell({
  number,
  className,
  rounded,
  formatter,
}: NumberCellProps) {
  if (number === null || number === undefined) {
    return <p className={cn('text-gray-500 text-right', className)}>-</p>;
  }

  const fmt =
    formatter ?? (rounded ? (n: number) => n.toFixed() : formatSmallNumber);

  return (
    <p className={cn('text-right', className)}>
      <SmallNumber value={number} formatter={fmt} />
    </p>
  );
}
